import cx from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@gov-nx/ui/web';

export interface SideBoxHeaderProps {
	children: React.ReactNode;
	link: string;
	customClasses?: string;
}

export const SideBoxHeader = ({
	children,
	link,
	customClasses,
}: SideBoxHeaderProps) => (
	<Link
		to={link}
		className={cx(
			'anim-bg-hover flex justify-between items-center gap-(--spacing-s-nudge) px-(--spacing-m-nudge) py-(--templates-margin-m) bg-(--background-primary-subtle) text-(--text-primary-color) text-headline-xs no-underline! [ md:-mx-0 md:-mt-0 md:rounded-t-3xl ]',
			customClasses
		)}>
		<div className="flex items-center gap-(--spacing-s-nudge)">{children}</div>
		<Icon
			name="chevron-right"
			type="components"
		/>
	</Link>
);
